import { render, staticRenderFns } from "./home_text.vue?vue&type=template&id=a3c07abc&scoped=true"
import script from "./home_text.vue?vue&type=script&lang=js"
export * from "./home_text.vue?vue&type=script&lang=js"
import style0 from "./home_text.vue?vue&type=style&index=0&id=a3c07abc&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a3c07abc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\a-项目\\付好佳\\多用户商城商家端\\fhj-web-dyh-mer\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a3c07abc')) {
      api.createRecord('a3c07abc', component.options)
    } else {
      api.reload('a3c07abc', component.options)
    }
    module.hot.accept("./home_text.vue?vue&type=template&id=a3c07abc&scoped=true", function () {
      api.rerender('a3c07abc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/maintain/components/mobileFormPage/home_text.vue"
export default component.exports